import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ProductReleaseCommentDialogComponent } from './product-release-comment-dialog.component';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
    ],
    exports: [ProductReleaseCommentDialogComponent],
    declarations: [ProductReleaseCommentDialogComponent],
    providers: [],
})
export class ProductReleaseCommentDialogModule { }
